<script>
  import { boolean } from '@st-graphics/graphics-kit/utils'
  import { isPremium } from '@st-graphics/graphics-kit/state'
  import { Headline, Photo, Video, PremiumLabel } from '@st-graphics/graphics-components'

  let {
    navbar,
    byline,
    datetime,
    modifieddatetime,
    deck,
    headline,
    objectfit = 'contain',
    type = 'photo',
    mobiledeck = 'false',
    mediamaxwidth = '100%',
    credit = null,
    caption = null,
    src,
    hasdesktop = 'true',
    poster = null,
    autoplay = false,
    alt,
    classname = '',
    menuitems,
    label = null,
    balancehed = true,
    balancedek = true,
    icon = undefined,
  } = $props()

  let headWidth = $state()

  let premiumContent = $derived(isPremium.current)
</script>

<div class="main-headline-head-wrapper">
  <div class="head" bind:clientWidth={headWidth}>
    <div class="nav">
      {@render navbar?.()}
      {@render menuitems?.()}
    </div>

    <div class={`article-head ${classname} ${headWidth < 744 ? 'md' : ''}`}>
      <div class="article-headline">
        <Headline
          {byline}
          hed={headline}
          dek={deck}
          {datetime}
          {modifieddatetime}
          mobiledeck={boolean(mobiledeck)}
          balancehed={boolean(balancehed)}
          balancedek={boolean(balancedek)}
        >
          {#snippet premium()}
            {#if premiumContent}
              <PremiumLabel />
            {/if}

            {#if icon}
              <div class="icon">
                <Photo src={icon} alt="" />
              </div>
            {/if}

            {#if label}
              <div class="label">
                <span>{label}</span>
              </div>
            {/if}
          {/snippet}
        </Headline>
      </div>
    </div>
  </div>

  <div class={`media ${objectfit}`}>
    <div class="media-container">
      <div class="container" style={`max-width: ${objectfit != 'cover' ? mediamaxwidth : '100%'}`}>
        {#if type === 'video'}
          <Video {src} {alt} {poster} autoplay={boolean(autoplay)} loop={true} muted={true} />
        {:else}
          <Photo {src} {alt} hasdesktop={boolean(hasdesktop)} />
        {/if}
      </div>
    </div>

    <div class="captions">
      <p class="caption">
        {#if caption}
          {caption}
        {/if}
        {#if credit}
          <span class="credit">{credit}</span>
        {/if}
      </p>
    </div>
  </div>
</div>

<style lang="scss">
  .main-headline-head-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 80px;
    background-color: var(--head-background, #f6f3ed);
    --link-text-decoration-color: currentcolor;

    @media (max-width: $screen-md) {
      grid-template-columns: 1fr;
    }

    .head {
      position: relative;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;

      @media (max-width: $screen-md) {
        height: fit-content;
      }

      .nav {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 999;
      }

      .article-head {
        text-align: center;
        min-height: 40vh;

        &.md {
          :global(.outer-wrapper .menu-wrapper .overlay-gradient) {
            display: block;
          }
        }
        .article-headline {
          pointer-events: none;
          @media (max-width: $screen-md) {
            margin-top: 114px;
          }

          :global(.headline) {
            pointer-events: all;
          }
          :global(.hed) {
            font-size: 56px;
            line-height: 59px;
            font-family: $font-selane-st-one;
            @media (max-width: $screen-md) {
              font-size: 37px;
              line-height: 42px;
            }
          }
        }
      }

      .label {
        color: currentcolor;
        font-size: 15px;
        text-transform: uppercase;
        font-family: var(--font-sans-serif);
        letter-spacing: 0.5rem;
        margin-bottom: 25px;
        margin-top: 0;
      }

      .icon {
        width: 100px;
        height: 100px;
        margin: 0 auto;
      }
    }

    .media {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      background-color: var(--splitscreen-media-background, #e9e9e9);

      .media-container {
        min-width: 100%;

        @media (max-width: $screen-md) {
          height: fit-content;
        }
      }

      &.contain {
        .media-container {
          width: 100%;
          height: 100%; //100vh
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          overflow: hidden;

          .container {
            width: 100%;

            @media (max-width: $screen-md) {
              justify-content: center;
            }
          }
        }
      }

      &.cover {
        :global(img),
        :global(video) {
          width: 100%;
          height: 100vh;
          object-fit: cover;

          @media (max-width: $screen-md) {
            min-height: 50%;
            height: 60vh;
            object-fit: cover;
          }
        }
      }

      .captions {
        width: 100%;
        position: absolute;
        top: 100%;
        font-family: var(--font-sans-serif);
        font-size: 15px;
        color: #7b7b7b;

        .caption {
          width: 100%;
          max-width: 800px;
          display: block;
          padding: 5px 15px;

          span {
            font-size: 11px;
          }
        }
      }
    }
    :global(.headline .wrapper:last-of-type) {
      border: none;
    }
  }

  :global(.inline-menu.outer-wrapper) {
    left: 0;
  }
  :global(.menu-wrapper .overlay-gradient) {
    background: linear-gradient(
      to left,
      var(--head-background) 0.1%,
      rgba(255, 255, 255, 0) 99.9%
    ) !important;
  }
</style>
